<template>
  <span id="time">{{ minutes }} : {{ seconds }}</span>
</template>

<script>
import { mapGetters } from 'vuex'
import { clearInterval, setInterval } from 'worker-timers'

export default {
  props: ['isRecordPause'],
  data() {
    return {
      minutes: '',
      seconds: '',
      totalSeconds: 0,
      timerInterval: null,
      beforeTitle: document.title,
      countdown5s: new Audio(require('@/assets/audio/countdown_5s.mp3')),
      recordingEnd: new Audio(require('@/assets/audio/recording_end.mp3')),
    }
  },
  computed: {
    ...mapGetters(['wsClipCnt', 'userInfo']),
  },
  beforeDestroy() {
    this.recordingEnd.removeEventListener('ended', this.emitCompleteRecord)
  },
  methods: {
    // setTime() {
    //   --this.totalSeconds
    //   this.seconds = this.convertTime(this.totalSeconds % 60)
    //   this.minutes = this.convertTime(parseInt(this.totalSeconds / 60))
    // },
    convertTime(type) {
      let val = 0
      if (type === 'min') val = parseInt(this.totalSeconds / 60)
      else if (type === 'sec') val = this.totalSeconds % 60

      const valString = val + ''
      if (valString.length < 2) {
        return '0' + valString
      } else {
        return valString
      }
    },
    emitCompleteRecord() {
      this.$emit('completeRecord')
    },
    startTimer() {
      this.stopTimer(true)
      this.recordingEnd.addEventListener('ended', this.emitCompleteRecord)
      this.timerInterval = setInterval(() => {
        if (!this.isRecordPause) {
          this.totalSeconds--
          this.minutes = this.convertTime('min')
          this.seconds = this.convertTime('sec')
          document.title = this.minutes + ' : ' + this.seconds
          if (this.totalSeconds === 0) this.recordingEnd.play()
          else if (0 < this.totalSeconds && this.totalSeconds <= 5 && this.countdown5s.paused) this.countdown5s.play()
        } else {
          this.recordingEnd.pause()
          this.countdown5s.pause()
        }
      }, 1000)

      // this.timerInterval = setInterval(this.setTime, 1000)
    },
    stopTimer(isInit) {
      if (this.timerInterval && this.timerInterval !== null) clearInterval(this.timerInterval)
      if (this.recordingEnd && this.recordingEnd !== null) {
        this.recordingEnd.pause()
        this.recordingEnd.currentTime = 0
      }
      if (this.countdown5s && this.countdown5s !== null) {
        this.countdown5s.pause()
        this.countdown5s.currentTime = 0
      }

      document.title = this.beforeTitle

      // 클립 업로드 시간제한으로 게스트를 제외한 나머지 60분으로 변경
      if (this.userInfo && this.userInfo['userStatus'] !== 'G' && this.wsClipCnt['isWsMember'] === true)
        this.totalSeconds = 60 * 60
      // 게스트일 경우 7분
      else this.totalSeconds = 7 * 60

      // // 유료 사용자는 60분
      // if (this.wsClipCnt && this.wsClipCnt['planType'] === 'Plus') {
      //   this.totalSeconds = 60 * 60
      // }
      // // 특정 고객 15분 녹화로 적용
      // else if (this.$route.params && this.$route.params['wsDomain'] === 'sgiv') {
      //   this.totalSeconds = 15 * 60
      // }
      // // 기본 5분
      // else {
      //   this.totalSeconds = 5 * 60
      // }

      this.timerInterval = null
      if (isInit) {
        this.minutes = this.convertTime('min')
        this.seconds = this.convertTime('sec')
      }
    },
    // setTitle(extra) {
    //   document.title =
    //     location.pathname
    //       .split('/')
    //       .map(function (v) {
    //         return v.replace(/\.(html|php)/, '').replace(/^\w/, function (a) {
    //           return a.toUpperCase()
    //         })
    //       })
    //       .join(' | ') + (extra && ' | ' + extra)
    // },
  },
}
</script>

<style scoped>
#time {
  display: inline-block;
  color: #eee;
  background-color: #161d21;
  padding: 5px;
  border-radius: 5px;
  min-width: 65px;
  text-align: center;
  font-size: 14px;
}
</style>
